module.exports = __webpack_public_path__ + "static/Finra-12af5792da6ef731e944c12229c7b5ee.png";